import ForgotPasswordForm from 'components/modules/auth/ForgotPasswordForm';
import { setItemToStore } from 'helpers/utils';
import AuthCardLayout from 'layouts/AuthCardLayout';
import { useEffect, useState } from 'react';
import { useMutation } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { FORGET_PASSWORD } from 'services';
import { useForm } from 'react-hook-form';

const ForgotPassword = () => {
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm({
    defaultValues: {
      email: ''
    }
  });
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [message, setMessage] = useState<string>('');
  const [isSuccessful, setIsSuccessful] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const navigate = useNavigate();
  useEffect(() => {
    if (isSuccessful) {
      setIsLoading(false);
      navigate('/auth/change-password');
    }
  }, [isSuccessful]);

  const forgetPassword = useMutation('login', FORGET_PASSWORD, {
    onSuccess: (data: any) => {
      setIsSuccessful(true);
      const {
        data: { message }
      } = data.data;
      setMessage(message);
    },
    onMutate: () => {
      setIsLoading(true);
    },
    onError: (error: any) => {
      setErrorMessage(error?.response?.data?.message);
      setIsLoading(false);
    }
  });

  const onSubmit = async (data: { email: string }) => {
    try {
      setItemToStore('forgetPasswordEmail', data.email);
      await forgetPassword.mutateAsync({ email: data.email });
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <AuthCardLayout>
      <ForgotPasswordForm
        register={register}
        handleSubmit={handleSubmit(onSubmit)}
        errors={errors}
        errorMessage={errorMessage}
        message={message}
        isLoading={isLoading}
        setErrorMessage={setErrorMessage}
      />
    </AuthCardLayout>
  );
};

export default ForgotPassword;
